import { useNavigate } from "react-router-dom";
import { customNoAuthAxios } from "../../utils/customNoAuthAxios";
import { getRandomStringWithDate } from "../../utils/getRandomStringWithDate";

type SelectedQuestions = {
  id: string;
  question: string;
  question_content: string;
}[]

export const useSubmitKuchikomyuCustomerSurveyEn = (restaurantId: string, selectedQuestions: SelectedQuestions) => {
  const navigate = useNavigate();

  const onSubmit = async (data:any) => {
    const questions = selectedQuestions?.map(selectedQuestion => selectedQuestion.question);
    data['restaurant_id'] = restaurantId
    data['questions'] = questions
    data['survey_set_id'] = getRandomStringWithDate()
    try {
      const res = await customNoAuthAxios.post(
        'kuchikomyu/survey/answer/customer/',
        data,
      );

      // アンケート完了後の遷移先を決定（sessionStorage 経由）
      let nextUrl: string | null = null;
      try {
        nextUrl = sessionStorage.getItem('kuchikomyu:nextUrl');
      } catch (_) {
        nextUrl = null;
      }

      const isHttpUrl = (u?: string | null) => !!u && /^https?:\/\//i.test(u);
      const isInternalPath = (u?: string | null) => !!u && u.startsWith('/');

      if (isHttpUrl(nextUrl)) {
        window.location.href = nextUrl!;
        return;
      }
      if (isInternalPath(nextUrl)) {
        navigate(nextUrl!, { replace: true });
        return;
      }

      // フォールバック
      navigate(`/thanks`);

    } catch (error:any) {
    } finally {
    }
  };

  return onSubmit;
};